import { clientConfig } from '@/config/clientConfig';
import { urls } from '@/shared/utils/urls';

const SSK_RETURN_URL = 'myhubdemo_return_url';

// http://localhost:3000/?returnUrl=https%3A%2F%2Fgoogle.com
export const saveMyHubDemoReturnUrl = () => {
  const params = new URL(window.location.href).searchParams;
  const returnUrl = params.get('returnUrl');

  if (returnUrl && urls.isValidUrl(returnUrl)) {
    sessionStorage.setItem(SSK_RETURN_URL, returnUrl);
  }
};

export const getMyHubDemoReturnUrl = () => {
  const returnUrl = sessionStorage.getItem(SSK_RETURN_URL);

  if (returnUrl && urls.isValidUrl(returnUrl)) {
    return returnUrl;
  } else {
    return clientConfig.demoHub.defaultReturnUrl;
  }
};
